import { render, staticRenderFns } from "./prescription.vue?vue&type=template&id=d160110a&scoped=true&"
import script from "./prescription.vue?vue&type=script&lang=js&"
export * from "./prescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d160110a",
  null
  
)

export default component.exports